export default {"src":"/_next/static/media/center_logo.b8bfcb70.svg","height":118,"width":218};